var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useState, useCallback, useEffect } from "react";
import { useLibZLInstance } from "./LibZLInstanceProvider";
const Direct2DContext = React.createContext(undefined);
export const Direct2DProvider = ({ options, children }) => {
    const libZL = useLibZLInstance();
    const [direct2D, setDirect2D] = useState(null);
    const createDirect2DInstance = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!libZL || !options) {
            return;
        }
        const api = yield libZL.direct2D(undefined);
        const direct2D = yield api.connect(Object.assign({}, options));
        window.direct2D = direct2D;
        setDirect2D(direct2D);
    }), [libZL, options]);
    useEffect(() => {
        createDirect2DInstance();
    }, [createDirect2DInstance]);
    return React.createElement(Direct2DContext.Provider, { value: direct2D }, children);
};
export function useDirect2D() {
    return useContext(Direct2DContext);
}
